export const REPUTECH_DOMAIN = "reputech.io";
export const SUPPORT_EMAIL = "support@reputech.io";

export const getSiteUrl = () => {
  const configuredUrl = process.env.NEXT_PUBLIC_URL?.trim();
  return configuredUrl ? configuredUrl.replace(/\/$/, "") : "http://localhost:3000";
};
